import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Button from "./../../Common/Button";
import PanelHeaderMenu from "./PanelHeaderMenu";
import PanelMobileContextMenu from "./PanelMobileContextMenu";

export default class PanelHeader extends PureComponent {
  static propTypes = {
    actions: PropTypes.array,
    className: PropTypes.string,
    customAction: PropTypes.object,
    customLabel: PropTypes.object,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isFirstPage: PropTypes.bool,
    isMobile: PropTypes.bool,
    summaryButtonClick: PropTypes.func,
    summaryIsLoading: PropTypes.bool,
    title: PropTypes.string
  };

  static defaultProps = {
    actions: [],
    className: "",
    customAction: null,
    customLabel: null,
    id: "",
    isFirstPage: false,
    isMobile: false,
    summaryButtonClick: null,
    summaryIsLoading: false,
    title: ""
  };

  render() {
    const { actions, className, customAction, customLabel, id, isFirstPage, isMobile, summaryButtonClick, summaryIsLoading, title } = this.props;

    return (
      <div className={classNames(!isMobile && "panel-header__no-border")}>
        <header className={classNames("panel-header", className)}>
          <div className="panel-header__title-section">
            <PanelHeaderMenu isFirstPage={isFirstPage} isMobile={isMobile} />
            <div className="panel-header__context">
              {title && <p className="panel-header__title">{title}</p>}
              {customLabel || <p className="panel-header__id">{id && id}</p>}
              {isMobile && (
                <div className="panel-header__context-button-section">
                  {summaryIsLoading && <Button className={classNames("panel-header__summary-trigger")} onClick={summaryButtonClick} icon="info" />}
                  <PanelMobileContextMenu actions={actions} />
                </div>
              )}
            </div>
          </div>

          {!isMobile && (
            <div className="panel-header__button-section">
              {actions.map(
                action =>
                  !action.showOnlyOnMobile && (
                    <Button
                      key={action.label}
                      className={classNames("panel-header__button", action.className)}
                      onClick={action.onClick}
                      label={action.label}
                      icon={action.icon}
                    />
                  )
              )}
              {customAction}
            </div>
          )}
        </header>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/PanelHeader.js